import { render, staticRenderFns } from "./PostDetailFriendInvited.vue?vue&type=template&id=a8061ae8&scoped=true"
import script from "./PostDetailFriendInvited.vue?vue&type=script&lang=js"
export * from "./PostDetailFriendInvited.vue?vue&type=script&lang=js"
import style0 from "./PostDetailFriendInvited.vue?vue&type=style&index=0&id=a8061ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8061ae8",
  null
  
)

export default component.exports